import React from 'react'
import FJDropDown from "fj-components/FJDropDown";
import FJLocalStore from "../../../store/FJLocalStore";
import classNames from 'classnames'
import checkIcon from "../../../icon/check.svg";
import styles from './FJSpeed.module.less'
import FJToolbarButton from "./FJToolbarButton";
import InlineSVG from "react-inlinesvg";

function FJSpeedItem(props) {
  const {value, onClick, active, dropDown} = props;

  return (
    <div className={classNames(styles.item, {[styles.active]: active})} onClick={() => {
      onClick(value);
			dropDown.current.hide();
    }}>
      <span>{FJLocalStore._(value + 'x')}</span>
      <InlineSVG src={checkIcon} />
    </div>
  );
}

function FJSpeed(props) {
  const {speed, disabled, onSpeedChange, dropDown} = props;
  const playbackRates = [0.5, 0.75, 1, 1.5, 2, 3];
  return (
    <FJDropDown overlay={
      <div className='c-speed-overlay'>
        {
          playbackRates.map((value) => {
            return <FJSpeedItem key={value}
                                value={value}
                                active={value === speed}
                                onClick={onSpeedChange}
																dropDown={dropDown}
						/>;
          })
        }
      </div>
    }
                disabled={disabled}
                hasArrow={true}
                canTriggerActive
								ref={dropDown}
    >
      <FJToolbarButton disabled={disabled} style={{float: 'left'}} text={FJLocalStore._('speed')} />
    </FJDropDown>
  );
}

export default FJSpeed;